import React, { useCallback, useEffect, useState } from "react";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { useDispatch, useSelector } from "react-redux";
import { viewTeamMembersList, blockUnblockMember } from "../../Redux/Actions/teamMembersAction";
import { columnsTeams } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";

const ListTeamMembers = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  const { enumsData } = useSelector((state) => state.enumsData);

  const memberRole = enumsData?.data
    ? Object.values(enumsData.data.Roles).filter(role =>
      !["agent", "admin", "super_admin", "builder"].includes(role)
    )
    : [];

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const handleStatusChange = async (record, action) => {
    let payload = { id: record._id };

    if (action === "block") {
      payload.status = "BLOCK";
    } else if (action === "unblock") {
      payload.status = "UNBLOCK";
    } else {
      payload.status = action;
    }

    await dispatch(blockUnblockMember(payload));
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const fetchDetails = useCallback(async (page, pageSize, role, showLoader = true) => {
    const teamData = {
      page,
      limit: pageSize,
      is_deleted: false,
      role: role,
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(viewTeamMembersList(teamData, showLoader));

      if (!showLoader) {
        toast.success("kiosk list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh kiosk list");
      }
    }
  },
    [dispatch, debouncedSearch, dateRange]
  )

  const { loading } = useSelector((state) => state.teamMembers);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize, memberRole);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  const { teamMembers } = useSelector((state) => state.teamMembers);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    if (teamMembers?.total) {
      setPagination((prevData) => ({ ...prevData, total: teamMembers.total }));
    }
  }, [teamMembers]);

  console.log("DAATAT", teamMembers)

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponent
        h3heading="Staff Members"
        setState={setSearchQuery}
        buttonhead2="Add Staff Members"
        // filterFunction={filterHandler}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        navigateTo2="/team/add"
        dataSource={(Array.isArray(teamMembers?.data) && teamMembers.data) || []}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}
        columns={columnsTeams(handleStatusChange)}
      ></TableComponent>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListTeamMembers;
